import React, { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './useAuth';

/**
 * Route guard: renders its children only for an authenticated user. While Entra
 * External ID (MSAL) is resolving the session it shows a lightweight loader; if
 * the user is signed out it redirects to the in-app `/login` page.
 */
export const RequireAuth: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="auth-loading" style={{ display: 'grid', placeItems: 'center', minHeight: '60vh' }}>
        <i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }} aria-label="Signing in" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};
